export default __webpack_public_path__ + "static/media/ira2.b3c3c833.jpg";